import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { ACTIONS } from "../../../../common/Constants";
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../../../common/FormRenderer";
import { getValue } from "../../../../../utils/common";
import { GetActionTitle } from "../../Master.constants";

function VerticalDetails({ action, record : data, onClose }: any) {

    const [vertical, setvertical] = useState<any>({ hideButtons: true });

    const schema = {
        fields: [
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'company',
                label: 'Company',
                content: action !== ACTIONS.ADD ? getValue(vertical, 'company.label') : null
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'name',
                label: 'Vertical Name',
                content: getValue(vertical, 'name')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'short_code',
                label: 'Vertical Code',
                styleClass: 'text-uppercase',
                content: getValue(vertical, 'short_code')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'description',
                label: 'Description',
                content: getValue(vertical, 'description')
            }
        ]
    };

    useEffect(() => {
        if (data) {
            const { id, name } = data.company || {};
            setvertical({
                ...vertical,
                ...data,
                company: { value: id, label: name }
            });
        }
    }, [data]);

    return (
        <>
            <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
                <Modal.Header closeButton={true} onHide={onClose}>
                    <Modal.Title className="bg">{GetActionTitle('Vertical', action)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormRenderer FormTemplate={FormTemplate}
                        initialValues={vertical}
                        componentMapper={ComponentMapper}
                        schema={schema}
                    />
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    {
                        <Button variant="primary" onClick={onClose} className="px-4 ms-auto">{'Close'}</Button>
                    }
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default VerticalDetails;